import { createReducer, on } from '@ngrx/store';
import { SearchExportState, initialSearchExportState } from './search-export.state';
import * as SearchExportActions from './search-export.actions';

export const searchExportReducer = createReducer(
  initialSearchExportState,

  // ============================================
  // Start Export
  // ============================================
  on(SearchExportActions.startSearchExport, (state): SearchExportState => ({
    ...state,
    startExport: {
      isLoading: true,
      result: null,
      error: null
    }
  })),

  on(SearchExportActions.startSearchExportSuccess, (state, { result }): SearchExportState => ({
    ...state,
    startExport: {
      isLoading: false,
      result,
      error: null
    }
  })),

  on(SearchExportActions.startSearchExportFailure, (state, { error }): SearchExportState => ({
    ...state,
    startExport: {
      isLoading: false,
      result: null,
      error: error?.error?.message || error?.message || 'Failed to start export'
    }
  })),

  // ============================================
  // Load Exports
  // ============================================
  on(SearchExportActions.loadSearchExports, (state): SearchExportState => ({
    ...state,
    exports: {
      ...state.exports,
      isLoading: true,
      error: null
    }
  })),

  on(SearchExportActions.loadSearchExportsSuccess, (state, { exports, pagination }): SearchExportState => ({
    ...state,
    exports: {
      items: exports,
      isLoading: false,
      error: null,
      pagination
    }
  })),

  on(SearchExportActions.loadSearchExportsFailure, (state, { error }): SearchExportState => ({
    ...state,
    exports: {
      ...state.exports,
      isLoading: false,
      error: error?.error?.message || error?.message || 'Failed to load exports'
    }
  })),

  // ============================================
  // Download Export
  // ============================================
  on(SearchExportActions.downloadSearchExport, (state, { exportId }): SearchExportState => ({
    ...state,
    download: {
      downloadingIds: [...state.download.downloadingIds, exportId],
      error: null
    }
  })),

  on(SearchExportActions.downloadSearchExportSuccess, (state, { exportId }): SearchExportState => ({
    ...state,
    download: {
      downloadingIds: state.download.downloadingIds.filter(id => id !== exportId),
      error: null
    }
  })),

  on(SearchExportActions.downloadSearchExportFailure, (state, { exportId, error }): SearchExportState => ({
    ...state,
    download: {
      downloadingIds: state.download.downloadingIds.filter(id => id !== exportId),
      error: error?.error?.message || error?.message || 'Failed to download export'
    }
  })),

  // ============================================
  // Reset
  // ============================================
  on(SearchExportActions.resetSearchExportState, (): SearchExportState => ({
    ...initialSearchExportState
  })),

  on(SearchExportActions.resetStartExportState, (state): SearchExportState => ({
    ...state,
    startExport: {
      isLoading: false,
      result: null,
      error: null
    }
  }))
);

export type { SearchExportState };
